import { Typography } from "@mui/material";
import { useRecordContext, Labeled } from "react-admin";

/**
 * Read-only field display component for use in in-place editing layouts.
 *
 * Renders a plain text value from the current record using {@link Typography},
 * wrapped in a {@link Labeled} component to optionally show a label.
 * This component does not support editing and is useful for fields that should be visible
 * but immutable in editable views.
 *
 * @param label - Optional label to display above the field
 * @param source - Field name to display from the current record
 * @returns A labeled, non-editable text field
 */
export const ReadOnlyInPlaceEditor = ({ label, source }: { label?: string; source: string }) => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <Labeled label={label}>
      <Typography variant="body1" sx={{ display: "block", mb: 0.5 }}>
        {record[source] ?? "-"}
      </Typography>
    </Labeled>
  );
};
